import React from 'react';
import "../src/assests/sass/Style.scss";
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from './redux/store';
import Home from './component/Home/Home';
import Header from './component/Home/Header/Header';
import Footer from './component/Home/Footer/Footer';
import AboutUs from './component/AboutUs/AboutUs';
import OurInspiration from './component/OurInspiration/OurInspiration';
import History from './component/History/History';
import OurVision from './component/OurVision/OurVision';
import OurEthos from './component/OurEthos/OurEthos';
import OurAims from './component/OurAims/OurAims';
import DownloadBrochure from './component/DownloadBrochure/DownloadBrochure';
import FeesStructure from './component/FeesStructure/FeesStructure';
import AdmissionProcedure from './component/AdmissionProcedure/AdmissionProcedure';
import OnlineRegistration from './component/OnlineRegistration/OnlineRegistration';
import Gallery from './component/Gallery/Gallery';
import SpiritualCareAndWellbeing from './component/SpiritualCareAndWellbeing/SpiritualCareAndWellbeing';
import AcademicLife from './component/AcademicLife/AcademicLife';
import SportingLife from './component/SportingLife/SportingLife';
import CoCurricular from './component/CoCurricular/CoCurricular';
import SocialResponsibility from './component/SocialResponsibility/SocialResponsibility';
import Activities from './component/Activities/Activities';
import Amenities from './component/Amenities/Amenities';
import SmartClassrooms from './component/SmartClassrooms/SmartClassrooms';
import Library from './component/Library/Library';
import ComputerLab from './component/ComputerLab/ComputerLab';
import ScienceLab from './component/ScienceLab/ScienceLab';
import Transport from './component/Transport/Transport';
import SkillLab from './component/SkillLab/SkillLab';
import SchoolClubs from './component/SchoolClubs/SchoolClubs';
import Downloads from './component/Downloads/Downloads';
import Sports from './component/Sports/Sports';
import Contact from './component/Contact/Contact';
import FounderMessage from './component/FounderMessage/FounderMessage';
import DirectorMessage from './component/DirectorMessage/DirectorMessage';
import PatronMessage from './component/PatronMessage/PatronMessage';
import Blog from './component/Blog/Blog';
import BlogPostTitle from './component/BlogPostTitle/BlogPostTitle';

function App() {

  function CommonHeader() {
    return (
      <>
        <Header />
        <Outlet />
        <Footer />
      </>
    );
  };

  return (
    <>
      <Provider store={store}>
        <Router>
          <Routes>
            {/* <Route path="/" element={<Login />} /> */}

            <Route element={<CommonHeader />}>
              <Route path="/" element={<Home />} />
              <Route path="about-us" element={<AboutUs />} />
              <Route path="our-inspiration" element={<OurInspiration />} />
              <Route path="history" element={<History />} />
              <Route path="our-vision" element={<OurVision />} />
              <Route path="our-ethos" element={<OurEthos />} />
              <Route path="our-aims" element={<OurAims />} />
              <Route path="online-registration" element={<OnlineRegistration />} />
              <Route path="admission-procedure" element={<AdmissionProcedure />} />
              <Route path="fees-structure" element={<FeesStructure />} />
              <Route path="download-brochure" element={<DownloadBrochure />} />
              <Route path="spiritual-care-and-wellbeing" element={<SpiritualCareAndWellbeing />} />
              <Route path="academic-life" element={<AcademicLife />} />
              <Route path="sporting-life" element={<SportingLife />} />
              <Route path="co-curricular" element={<CoCurricular />} />
              <Route path="social-responsibility" element={<SocialResponsibility />} />
              <Route path="activities" element={<Activities />} />
              <Route path="amenities" element={<Amenities />} />
              <Route path="smart-classrooms" element={<SmartClassrooms />} />
              <Route path="library" element={<Library />} />
              <Route path="computer-lab" element={<ComputerLab />} />
              <Route path="science-lab" element={<ScienceLab />} />
              <Route path="sports" element={<Sports />} />
              <Route path="transport" element={<Transport />} />
              <Route path="skill-lab" element={<SkillLab />} />
              <Route path="school-clubs" element={<SchoolClubs />} />
              <Route path="downloads" element={<Downloads />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="contact-us" element={<Contact />} />
              <Route path="founder-message" element={<FounderMessage />} />
              <Route path="director-message" element={<DirectorMessage />} />
              <Route path="patron-message" element={<PatronMessage />} />
              <Route path="blog" element={<Blog />} />
              <Route path="blog-post-title" element={<BlogPostTitle />} />
            </Route>

          </Routes>
        </Router>
      </Provider>
    </>
  );
}

export default App;
